"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("@turf/helpers");
var distance_1 = __importDefault(require("@turf/distance"));
var ngraph_path_1 = __importDefault(require("ngraph.path"));
var utils_1 = require("./utils");
var multiRouteCalculator = function (graph, waypoints, pathFinderOptions, options) {
    if (options === void 0) { options = { units: "kilometers" }; }
    var allRoutes = [];
    var units = options.units, connectAllWaypoints = options.connectAllWaypoints, minDistance = options.minDistance;
    var totalDistance = 0;
    waypoints.forEach(function (_a, index) {
        var coor = _a.coor, properties = _a.properties;
        // Skip calculation when index = 0
        if (index) {
            // 0. Check if the distance between waypoint is less than X. If so, then skip calculation in its entirety
            if (minDistance) {
                // The units to calculate minimum distance can be different from the desired output distance units
                var waypointDistance = (0, distance_1.default)(waypoints[index - 1].coor, coor, {
                    units: minDistance.units,
                });
                if (waypointDistance < minDistance.distance) {
                    var segmentDistance_1 = Math.floor((0, distance_1.default)(waypoints[index - 1].coor, coor, {
                        units: units,
                    }));
                    allRoutes.push({
                        path: [[waypoints[index - 1].coor, coor]],
                        distance: segmentDistance_1,
                    });
                    totalDistance += segmentDistance_1;
                    return;
                }
            }
            // 1. Process the start and finish points in the event that it crosses the 180 degree meridian
            var _start = (0, utils_1.roundDownPosition)(waypoints[index - 1].coor);
            var _finish = (0, utils_1.roundDownPosition)(coor);
            if (_start.join(",") === _finish.join(",")) {
                allRoutes.push({
                    path: [],
                    distance: 0,
                    properties: __assign(__assign({}, properties), { units: options.units }),
                });
                return;
            }
            var _b = (0, utils_1.processMeridianCrossing)(_start, _finish), _c = _b.coord, start = _c[0], finish = _c[1], changed = _b.changed, direction = _b.direction;
            // 2. Identify the graph to be used based on the direction in step 1
            var useGraph = graph.mainGraph;
            if (changed && direction === "LTR") {
                useGraph = graph.positiveGraph;
            }
            if (changed && direction === "RTL") {
                useGraph = graph.negativeGraph;
            }
            // 3. Identify the nearest coordinate within the vertice
            var nearestStart = (0, utils_1.getNearestNeighbour)(start, useGraph.vertices);
            var nearestFinish = (0, utils_1.getNearestNeighbour)(finish, useGraph.vertices);
            // If the nearest neighbour cannot be found stop the calculation
            if (!nearestStart || !nearestFinish)
                return null;
            // 4. Select the path finding algorithm to use
            var aStarFunc = ngraph_path_1.default.aStar(useGraph.graph, pathFinderOptions);
            // 5. Run the algorithm with the start and finish points
            var nodes = aStarFunc.find(nearestStart.join(","), nearestFinish.join(","));
            var paths = nodes.map(function (node) {
                return (0, utils_1.roundDownPosition)([node.data.x, node.data.y]);
            });
            // 6. Process connecting nodes to waypoints
            if (connectAllWaypoints) {
                paths.push(_start);
                paths.unshift(_finish);
            }
            else {
                if (index === 1) {
                    paths.push(_start);
                }
                if (index === waypoints.length - 1) {
                    paths.unshift(_finish);
                }
            }
            var reversePath = paths.reverse(); // the generated paths are reversed
            // 7. Check if the calculated route has to be broken apart for proper display on the map
            var correctedPaths = (0, utils_1.breakMeridianPaths)(reversePath, direction);
            var segmentDistance = correctedPaths.reduce(function (acc, groupPath) {
                var groupPathLength = groupPath.reduce(function (innerAcc, path, index) {
                    if (index === 0) {
                        return innerAcc;
                    }
                    else {
                        return (innerAcc +
                            (0, distance_1.default)((0, helpers_1.point)(path), (0, helpers_1.point)(groupPath[index - 1]), { units: units }));
                    }
                }, 0);
                return acc + groupPathLength;
            }, 0);
            allRoutes.push({
                path: correctedPaths,
                distance: Math.floor(segmentDistance),
                properties: __assign(__assign({}, properties), { units: options.units }),
            });
            totalDistance += segmentDistance;
        }
    });
    return {
        routes: allRoutes,
        distance: Math.floor(totalDistance),
    };
};
exports.default = multiRouteCalculator;
